const boxShadows = {
  xs: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  sm: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
  xxl: "0 25px 50px -12px rgb(0 0 0 / 0.25)", // Alias for 2xl for compatibility
  inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
  none: "0 0 #0000",

  // Deprecated legacy shadows for backwards compatibility
  xxs: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  regular: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",

  navbarBoxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  sliderBoxShadow: {
    thumb: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  },
  tabsBoxShadow: {
    indicator: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  },
  inset: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",

  // Colored shadows
  colored: {
    primary: "0 4px 20px 0px rgba(26, 115, 232, 0.14)",
    secondary: "0 4px 20px 0px rgba(68, 71, 70, 0.12)",
    info: "0 4px 20px 0px rgba(26, 115, 232, 0.14)",
    success: "0 4px 20px 0px rgba(30, 142, 62, 0.14)",
    warning: "0 4px 20px 0px rgba(249, 171, 0, 0.16)",
    error: "0 4px 20px 0px rgba(217, 48, 37, 0.14)",
    light: "0 4px 20px 0px rgba(189, 193, 198, 0.2)",
    dark: "0 4px 20px 0px rgba(32, 33, 36, 0.18)",
  },
};

export default boxShadows;
